import {
    CHANGE_LANGUAGE_SUCCESS,
    FETCH_LOCALE_FILES_SUCCESS,
    FETCH_LOCALE_FILES_FAILED,
    FETCH_LOCALE_FILES
} from 'constants/actionTypes';
import { ENGLISH, JAPANESE, SPANISH } from 'constants/language';
import axios from 'axios';
import i18n from 'i18next';

export const loadAdditionalTranslations = async (resources) => Promise.all(resources.map(async (resource) => {
    const res = await axios.get(resource.url);
    i18n.addResourceBundle(resource.locale, 'translation', {
        ...res
    }, true, false);
}));

export const changeLanguage = language => {
    return dispatch => {
        dispatch({ type: CHANGE_LANGUAGE_SUCCESS, payload: language });
        i18n.changeLanguage(language);
    };
};

export const fetchLocales = () => {
    return async (dispatch) => {
        dispatch({ type: FETCH_LOCALE_FILES, payload: null });
        try {
            await loadAdditionalTranslations([
                {
                    url: `${ process.env.LOCALE_FILE_EN }?version=${ process.env.BUILD_HASH }`,
                    locale: ENGLISH
                },
                {
                    url: `${ process.env.LOCALE_FILE_JA }?version=${ process.env.BUILD_HASH }`,
                    locale: JAPANESE
                },
                {
                    url: `${ process.env.LOCALE_FILE_ES }?version=${ process.env.BUILD_HASH }`,
                    locale: SPANISH
                },
                {
                    url: `${ process.env.LOCALE_FILE_HU }?version=${ process.env.BUILD_HASH }`,
                    locale: 'Hungarian'
                },
                {
                    url: `${ process.env.LOCALE_FILE_ERRORS_EN }?version=${ process.env.BUILD_HASH }`,
                    locale: ENGLISH
                },
                {
                    url: `${ process.env.LOCALE_FILE_ERRORS_JA }?version=${ process.env.BUILD_HASH }`,
                    locale: JAPANESE
                }
            ]);
            dispatch({ type: FETCH_LOCALE_FILES_SUCCESS, payload: null });
        } catch (err) {
            dispatch({ type: FETCH_LOCALE_FILES_FAILED, payload: null });
            throw err;
        }
    };
};
